import React, { useEffect, useState } from "react";
import {
  fetchNativeFeatures,
  INativeFeatures,
} from "@origin-digital/event-dispatcher";
import { useAppContext } from "../../AppContext";
import { Chat } from "./Chat";

export const ChatController = (): JSX.Element => {
  const { isNative } = useAppContext();
  const [nativeChatSupported, setNativeChatSupported] = useState<
    boolean | undefined
  >();

  useEffect(() => {
    //check if live chat is supported in app
    if (isNative) {
      appDetails().then((data) => {
        const { features } = data || {};
        if (features && features.asyncMessaging === true) {
          setNativeChatSupported(true);
        }
      });
    } else {
      setNativeChatSupported(false);
    }
  }, []);

  const appDetails = async (): Promise<INativeFeatures | undefined> => {
    const nativeFeatures = await fetchNativeFeatures({});
    return nativeFeatures;
  };

  return <Chat isNative={isNative} nativeChatSupported={nativeChatSupported} />;
};
